import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=561f9f6b&scoped=true&"
import script from "./Legend.vue?vue&type=script&lang=js&"
export * from "./Legend.vue?vue&type=script&lang=js&"
import style0 from "./Legend.vue?vue&type=style&index=0&id=561f9f6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561f9f6b",
  null
  
)

export default component.exports